'use client';
import React, { useEffect, useState } from 'react';
import styled from '@benzinga/themetron';
import { CoinInput, CoinList } from '@benzinga/crypto';

export interface CoinListProps {
  innerHTML?: string;
}

export const CoinListBlock: React.FC<CoinListProps> = ({ innerHTML }) => {
  const [coins, setCoins] = useState<CoinInput[]>([]);

  useEffect(() => {
    if (!innerHTML) return;
    const elem = document.createElement('div');
    elem.innerHTML = innerHTML;
    const coinList = elem.querySelector('#crypto-widget-CoinList');
    const coinsString = coinList?.getAttribute('data-coins') ?? '';
    const coinsArray = coinsString?.split(',') ?? [];
    const coinData = coinsArray.map((slug: string) => {
      return { name: '', slug, symbol: '' };
    });
    setCoins(coinData);
  }, [innerHTML]);

  if (coins.length === 0) return null;

  return (
    <Container className="coin-list-block">
      <CoinList coins={coins} />
    </Container>
  );
};

const Container = styled.div`
  &.coin-list-block {
    border-radius: 4px;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding: 0.5rem 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .coin-list-container {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      max-width: 500px;
      width: 100%;
    }
  }
`;
